import {
	CORE_PROJECT,
	SERVICE_DESK_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types.tsx';
import type { ProjectState } from '../model/types.tsx';

export const isJwmProject = (projectState: ProjectState | null) =>
	projectState?.projectType === CORE_PROJECT;

export const isJsmProject = (projectState: ProjectState | null) =>
	projectState?.projectType === SERVICE_DESK_PROJECT;
